// Assembles the 7 Mon–Sun day slots for the Log view's currently visible
// week — one row-input per grid column. Pure, so it's testable in
// isolation and mirrors buildDayRows' role for Table/Calendar. LogView.js
// still owns its own useMemo around the per-date Maps passed in here, so
// changing the visible week doesn't force those Maps to rebuild.
import moment from "moment";

export const buildWeekDaySlots = (
  monday,
  { dayMap, statByDate, exercisesByDate, habitLogsByDate, fromUtc, toUtc }
) =>
  Array.from({ length: 7 }, (_, i) => {
    const utcDate = Number(
      moment(String(monday), "YYYYMMDD").add(i, "days").format("YYYYMMDD")
    );
    return {
      utcDate,
      row: dayMap.get(utcDate) ?? null,
      stat: statByDate.get(utcDate) ?? null,
      exercises: exercisesByDate.get(utcDate) ?? [],
      habitLog: habitLogsByDate.get(utcDate) ?? null,
      outOfRange: utcDate < fromUtc || utcDate > toUtc,
    };
  });
